import axios from "axios";
import FindLocation from "../models/FindLocation";
import { DefaultModel } from "../models/IModel";
import Location, { LocationDetail } from "../models/Location";
import { PriceDetail } from "../models/Order";
import http from "./http";
import environments from "../environment";

export async function getRecommendLocation(): Promise<{
	data: Location[];
}> {
	let results = await http.get(`/recommend-location`);
	return {
		data: DefaultModel.parseList<Location>(results.data, () => new Location()),
	};
}

export async function getRecommendLocationSSR(): Promise<{
	dataRecommendLocation: Location[];
	rawRecommendLocation: any;
}> {
	let headers = {};
	const { data } = await axios.get((environments.localApiRoot || environments.apiRoot) + `/recommend-location`, {
		timeout: environments.localApiTimeout || undefined,
		headers,
	});
	return {
		dataRecommendLocation: DefaultModel.parseList<Location>(data, () => new Location()),
		rawRecommendLocation: data,
	};
}

export async function offlinegetRecommendLocation(raw: any): Promise<{ data: Location[] }> {
	let data = DefaultModel.parseList<Location>(raw, () => new Location());

	return { data };
}

export async function getTopDestinations(): Promise<{
	data: Location[];
}> {
	let results = await http.get(`/top-location?staticCount=9`);
	return {
		data: DefaultModel.parseList<Location>(results.data.docs, () => new Location()),
	};
}

export async function getAllTopDestinations(): Promise<{
	data: Location[];
}> {
	let results = await http.get(`/top-location`);
	return {
		data: DefaultModel.parseList<Location>(results.data, () => new Location()),
	};
}

export async function getTopDestinationsSSR(): Promise<{
	dataTopDestinations: Location[];
	rawTopDestinations: any;
}> {
	let headers = {};
	const { data } = await axios.get(
		(environments.localApiRoot || environments.apiRoot) + `/top-location?staticCount=9`,
		{
			timeout: environments.localApiTimeout || undefined,
			headers,
		}
	);
	return {
		dataTopDestinations: DefaultModel.parseList<Location>(data.docs, () => new Location()),
		rawTopDestinations: data.docs,
	};
}

export async function offlineGetTopDestinations(raw: any): Promise<{ data: Location[] }> {
	let data = DefaultModel.parseList<Location>(raw, () => new Location());

	return { data };
}

export const searchLocation = async (search: string) => {
	let results = await http.get(`/search-location?search=${encodeURIComponent(search)}`);
	return results;
};

export const locationDetail = async (id: string) => {
	let results = await http.get(`/location-detail/${id}`);

	const data = new LocationDetail().parse(results.data);
	return data;
};

export const partnerDetail = async (id: number) => {
	let results = await http.get(`/partner-detail/${id}`);

	const data = new FindLocation().parse(results.data);
	return data;
};

export const getOrderDetail = async (id: string, code?: string | null) => {
	const params = code ? `?code=${encodeURIComponent(code)}` : "";
	let results = await http.get(`/order-detail/${id}${params}`);

	const data = new PriceDetail().parse(results.data);
	return data;
};

export const getOrderDetailByAdmin = async (id: string) => {
	let results = await http.get(`/order-detail-by-admin/${id}`);

	const data = new PriceDetail().parse(results.data);
	return data;
};

export async function getListDestinations(
	page?: number | null,
	perPage?: number | null
): Promise<{
	data: Location[];
	count: number;
}> {
	let results = await http.get(`/top-location?page=${page || 1}&perPage=${perPage || 15}`);
	return {
		data: DefaultModel.parseList<Location>(results.data.docs, () => new Location()),
		count: results.data.total,
	};
}
export async function offlineGetListDestinations(raw: any): Promise<{ data: Location[]; count: number }> {
	let data = DefaultModel.parseList<Location>(raw.docs, () => new Location());

	return { data: data, count: raw.total };
}

export async function getListDestinationsSSR(
	page?: number | null,
	perPage?: number | null
): Promise<{
	dataGetListDestinations: Location[];
	rawGetListDestinations: any;
	countListDes: number;
}> {
	let headers = {};
	const { data } = await axios.get(
		(environments.localApiRoot || environments.apiRoot) +
			`/top-location?page=${page || 1}&perPage=${perPage || 15}`,
		{
			timeout: environments.localApiTimeout || undefined,
			headers,
		}
	);
	return {
		dataGetListDestinations: DefaultModel.parseList<Location>(data.docs, () => new Location()),
		rawGetListDestinations: data,
		countListDes: data.total,
	};
}

export async function getListDetailDestinations(
	id: string,
	perPage: number,
	page: number
): Promise<{
	data: FindLocation[];
}> {
	let results = await http.get(`/partners-by-destination/${id}?page=${page}&perPage=${perPage}`);
	return {
		data: DefaultModel.parseList<FindLocation>(results.data.docs, () => new FindLocation()),
	};
}

export async function getListDetailDestinationsSSR(
	id: string,
	perPage: number,
	page: number
): Promise<{
	dataGetListDetailDestinations: FindLocation[];
	rawGetListDetailDestinations: any;
}> {
	let headers = {};
	const { data } = await axios.get(
		(environments.localApiRoot || environments.apiRoot) +
			`/partners-by-destination/${id}?page=${page}&perPage=${perPage}`,
		{
			timeout: environments.localApiTimeout || undefined,
			headers,
		}
	);
	return {
		dataGetListDetailDestinations: DefaultModel.parseList<FindLocation>(data.docs, () => new FindLocation()),
		rawGetListDetailDestinations: data,
	};
}

export async function offlineGetListDetailDestinations(raw: any): Promise<{ data: FindLocation[] }> {
	let data = DefaultModel.parseList<FindLocation>(raw.docs, () => new FindLocation());

	return { data };
}

export async function getDetailDestinations(id: string): Promise<{
	data: Location;
}> {
	let results = await http.get(`/top-location-detail?url=/${id}`);
	return {
		data: new Location().parse(results.data),
	};
}

export async function getDetailDestinationsSSR(id: string): Promise<{
	dataGetDetailDestination: Location;
	rawGetDetailDestination: any;
}> {
	let headers = {};
	const { data } = await axios.get(
		(environments.localApiRoot || environments.apiRoot) + `/top-location-detail?url=/${id}`,
		{
			timeout: environments.localApiTimeout || undefined,
			headers,
		}
	);
	return {
		dataGetDetailDestination: new Location().parse(data),
		rawGetDetailDestination: data,
	};
}

export async function offlineGetDetailDestination(raw: any): Promise<{ data: Location }> {
	let data = new Location().parse(raw);

	return { data };
}

export async function getListLocation(): Promise<{
	data: Location[];
}> {
	let results = await http.get(`/utility/admin-recommend-location-content`);
	return {
		data: DefaultModel.parseList<Location>(results.data, () => new Location()),
	};
}

export const UpdateLocationList = async (locationList: Location[]) => {
	const docs = locationList.map((loc) => ({
		name: loc.name,
		lat: loc.lat,
		long: loc.long,
	}));
	let { data } = await http.post(`/utility/admin-recommend-location-content`, docs);

	return data;
};
